import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	makeEdits: {
		id: 'experiment-legacy-content-macro.extension-handler.edit-legacy',
		defaultMessage: 'Make edits',
		description:
			'This message is displayed in a button above legacy content macros, inside Confluence Page Editors. On clicking the Legacy content macro becomes editable.',
	},
	legacyContentHeader: {
		id: 'experiment-legacy-content-macro.extension-handler.legacyContentHeader',
		defaultMessage: 'Legacy Content',
		description: 'Header for the legacy content extension in the editor.',
	},
	contentHasLimitedFunctionality: {
		id: 'experiment-legacy-content-macro.extension-handler.contentHasLimitedFunctionality',
		defaultMessage:
			'This is <strong>legacy</strong> content and has limited functionality. <link>Learn more</link>.',
		description:
			'Message indicating that the legacy content has limited functionality. Includes link to learn more about limited functionality',
	},
});
